import celticsLogo from './nba-celtics-logo.png';
import mavericksLogo from './nba-mavericks-logo.png';
import timberwolvesLogo from './nba-timberwolves-logo.png'; 
import lakersLogo from './nba-lakers-logo.png';
import knicksLogo from './nba-knicks-logo.png';
import pacersLogo from './nba-pacers-logo.png';
import pistonsLogo from './nba-pistons-logo.png';
import netsLogo from './nba-nets-logo.png';
import hawksLogo from './nba-hawks-logo.png';
import magicLogo from './nba-magic-logo.png';
import heatLogo from './nba-heat-logo.png';
import bucksLogo from './nba-bucks-logo.png';
import sixersLogo from './nba-sixers-logo.png';
import cavaliersLogo from './nba-cavaliers-logo.png';
import raptorsLogo from './nba-raptors-logo.png';
import bullsLogo from './nba-bulls-logo.png';
import pelicansLogo from './nba-pelicans-logo.png';
import hornetsLogo from './nba-hornets-logo.png';
import rocketsLogo from './nba-rockets-logo.png';
import grizzliesLogo from './nba-grizzlies-logo.png';
import jazzLogo from './nba-jazz-logo.png';
import sunsLogo from './nba-suns-logo.png';
import clippersLogo from './nba-clippers-logo.png';
import warriorsLogo from './nba-warriors-logo.png';
import trailBlazersLogo from './nba-trail-blazers-logo.png';
import wizardsLogo from './nba-wizards-logo.png';
import spursLogo from './nba-spurs-logo.png';
import okcLogo from './nba-okc-logo.png';
import nuggetsLogo from './nba-nuggets-logo.png';
import kingsLogo from './nba-kings-logo.png';


export const NbaLogoMapper = new Map([
    ['Celtics', celticsLogo],
    ['Mavericks', mavericksLogo],
    ['Timberwolves', timberwolvesLogo],
    ['Lakers', lakersLogo],
    ['Knicks', knicksLogo],
    ['Pacers', pacersLogo],
    ['Pistons', pistonsLogo],
    ['Nets', netsLogo],
    ['Hawks', hawksLogo],
    ['Magic', magicLogo],
    ['Heat', heatLogo],
    ['Bucks', bucksLogo],
    ['76ers', sixersLogo],
    ['Cavaliers', cavaliersLogo],
    ['Raptors', raptorsLogo],
    ['Bulls', bullsLogo],
    ['Pelicans', pelicansLogo],
    ['Hornets', hornetsLogo],
    ['Rockets', rocketsLogo],
    ['Grizzlies', grizzliesLogo],
    ['Jazz', jazzLogo],
    ['Suns', sunsLogo],
    ['Clippers', clippersLogo],
    ['Warriors', warriorsLogo],
    ['Trail Blazers', trailBlazersLogo],
    ['Wizards', wizardsLogo],
    ['Spurs', spursLogo],
    ['Thunder', okcLogo],
    ['Nuggets', nuggetsLogo],
    ['Kings', kingsLogo],
]);